import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

export const initialState = fromJS({
  dashboards: [],
});

export const actions = {
  [ActionTypes.getDashboards]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        dashboards: payload || [],
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.saveDashboard]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
      };
      return fromJS(newState);
    },
  },
};

export const dashboard = handleActions(actions, initialState);
